(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('RegistrationService', RegistrationService);

    RegistrationService.$inject = ['$http', 'API_URL', 'Upload', '$q'];

    function RegistrationService ($http, API_URL, Upload, $q) {

        var service = {
            storeAddressData: storeAddressData,
            getCurrentLogo: getCurrentLogo,
            storeLogoData: storeLogoData,
            getCurrentExhibitor: getCurrentExhibitor,
            deleteCoExhibitor: deleteCoExhibitor,
            loadFees: loadFees,
            loadCoExhibitors: loadCoExhibitors,
            createCoExhibitor: createCoExhibitor,
            uploadLogo: uploadLogo
        };

        return service;

        function getCurrentExhibitor(id) {
            if(id){
                return $http.get(API_URL + 'exhibitor/'+id);
            }else{
                return $http.get(API_URL + 'exhibitor');
            }
        }


        function storeAddressData (data,id) {
            if(id){
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/saveaddressdata/'+id,
                    data: data
                });
            }else{
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/saveaddressdata/',
                    data: data
                });
            }
        }

        function getCurrentLogo(id) {
            if (id) {
                return $http.get(API_URL + 'exhibitor/logo/' + id);
            } else {
                return $http.get(API_URL + 'exhibitor/logo');
            }
        }

        function storeLogoData(logo, id) {
            if (id) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/logo/' + id,
                    data: {
                        logo: logo
                    }
                });
            } else {
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/logo/',
                    data: {
                        logo: logo
                    }
                });
            }
        }

        function createCoExhibitor () {
            return $http({
                method: 'POST',
                url: API_URL + 'exhibitor/createcoexhibitor'
            });
        }

        function deleteCoExhibitor (id) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'exhibitor/coexhibitor/'+id,
            });
        }

        function loadCoExhibitors() {
            return $http.get(API_URL + 'exhibitor/coexhibitors');
        }

        function loadFees() {
            return $http.get(API_URL + 'project/fee');
        }

        function uploadLogo(file) {
            var data = {
                file: file
            };

            return Upload.upload({
                // TODO: Add to API => files/upload/exhibitorlogo
                url: API_URL + 'files/upload/exhibitorlogo',
                data: data
            }).then(function (response) {
                return response.data;
            }, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });
        }
    }
})();
